import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import { CurrentUserManager } from 'managers/currentUser';
import { IWCCStorageManager } from 'managers/iStorage';
import { TopicManager } from 'managers/topic';
import { Person } from 'models/person';
import { CommentsService } from 'services/comments';
import './pinButton.html';
import CommentRequestButtonVM, { CommentRequestButtonVMConfig } from './requestButton';
import TaskManager from "../../../managers/task";

const { discussionId } = settings;

@injectable()
export default class CommentPinButtonVM extends CommentRequestButtonVM {
    private commentId: Subscribable<string | undefined>
    private topicId: Subscribable<string | undefined>

    private canPin: Subscribable<boolean>

    isPinned: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: CommentRequestButtonVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager,
        @inject(wccModules.commentsService) private commentsService: CommentsService
    ) {
        super(config, info);

        this.commentId = this.comment.pluck(c => c.id);
        this.topicId = this.comment.pluck(c => c.topicId);
        this.isPinned = this.comment.pluck(c => c.isPinned, false);

        const currentUserManager = storage.get(CurrentUserManager, { discussionId });
        const user = currentUserManager.pluck(m => m.person);
        const isModeratorUser = user.pluck(u => u.isModerator, false);

        const topicManager = storage.get(TopicManager, { topicId: this.topicId });
        const topic = topicManager.pluck(t => t.topic);
        const isIdeation = topic.pluck(t => t.isIdeation, false);

        const taskManager = storage.get(TaskManager, { taskId: discussionId });
        const task = taskManager.pluck(t => t.task);
        const isHomework = task.pluck(t => t.isHomework);

        const participant = this.comment.mapNotNull(comment => Person.fromThread(comment));
        const isPinnableComment = participant.pluck(p => p.isModerator() || !p.isObserver(), false);

        this.canPin = ko.pureComputed(() => isModeratorUser() && isPinnableComment() && !isIdeation() && !isHomework());       
    }

    togglePinState = async () => {
        if (this.isLocked()) return;

        const commentId = this.commentId();
        const topicId = this.topicId();

        try {
            if (commentId == undefined || topicId == undefined)
                throw new Error(messages.InvalidRequest);

            this.isBusy(true);

            await this.commentsService.pin(topicId, commentId);
        } catch (ex) {
            system.handleError(ex);
        } finally {
            this.isBusy(false);
        }
    }

    protected override checkIfVisible() {
        return super.checkIfVisible() && this.canPin();
    }
}